'use client';

import { createContext } from 'react';

import { BehaviorSubject, Subject } from 'rxjs';

import { ProjectType } from '@/survey-graphql';

import {
  ProjectResponseModeEvent,
  ResponseMode,
} from './shared-survey-project-response-mode.types';

export interface ProjectResponseModeContextValue {
  /** Current project mode when on a UT project (HandsFree vs default). Defaults to 'Chat' when not set. */
  projectMode: 'Chat' | 'HandsFree';
  projectType: ProjectType | null;

  // Response mode state
  responseMode: ResponseMode;
  toggleResponseMode: () => void;
  setResponseMode: (mode: ResponseMode) => void;

  // Voice response state
  isListening: boolean;
  isStarting: boolean;
  currentTranscript: string;
  setCurrentTranscript: (transcript: string) => void;
  ingestTranscript: (transcript: string, isFinal: boolean) => void;
  error: string | null;
  audioLevelObservable: BehaviorSubject<number>;
  eventsObservable: Subject<ProjectResponseModeEvent>;
  audioDataObservable: Subject<{
    data: Int16Array;
    date: number;
  }>;
  startDateOfTranscript: () => number | null;
  lastDateOfTranscript: () => number | null;
  manuallyEditTranscript: (transcript: string) => void;
  getSampleRate: () => number;

  // Voice response actions
  startListening: (options?: { skipLocalMic?: boolean }) => Promise<void>;
  stopListening: (reset?: boolean) => Promise<void>;
  handleToggleListening: () => void;
  tokenLoading: boolean;
  sendForceEndpoint: () => void;
}

const ProjectResponseContext = createContext<
  ProjectResponseModeContextValue | undefined
>(undefined);

export default ProjectResponseContext;
